<template>
    <Steps :current="current - 1">
        <Step
            v-for="item in steps"
            :key="item.title"
            :title="item.title"
            :content="item.content"
        ></Step>
    </Steps>
</template>

<script>
    export default {
        name: "go-steps",
        props: {
            current: {
                type: Number,
                default: 0
            },
            steps: {type: Array, default: () => []}
        },
        computed: {},
        methods: {},
        mounted() {
        },
        components: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-steps.vue